<template>
		<div class="game-over-content">
			<div class="game-over-bg"></div>
			<div class="component-container">
				<div class="topBar" :style="{'background-image':'url('+ game_config.top_bar_background +')'}"></div>
				<div class="playerName">
					{{getAdjective}}<br  />{{getPlayerName}}
				</div>
				<div class="shark-rating-container">
					<div class="label">{{game_over.shark_rating_label}}</div>
					<div class="symbols">
						<div class="symbol" v-for="n in 5" :key="n">
							<template v-if="n <= calculatePercent">
								<img :src="game_over.shark_rating_symbol_filled" />
							</template>
							<template v-else>
								<img :src="game_over.shark_rating_symbol_open" />
							</template>
						</div>
					</div>
				</div>
			</div>
			<div class="vuebar-element" v-bar="{ preventParentScroll: true, useScrollbarPseudo: true}">
			<div class="vuebar-content">
				<div class="content">
					<div class="game-over-title" v-html="this.game_over.game_over_header"></div>
					<div class="game-over" v-html="game_over.game_over_content"></div>
					<Button class="startOverBtn" :action="redirect">{{game_over.button_text}}</Button>
					<ShareButtons :class="{ 'hidden': isBrainPop }"></ShareButtons>
					<div class="game-over2" v-html="game_over.game_over_content_2"></div>
				</div>
			</div>
		</div>
		</div>
</template>
<script>
import { mapState } from 'vuex';
import Button from '@/components/abstract/Button';
import ShareButtons from '@/components/abstract/ShareButtons';
import tracking from '@/mixins/tracking';
import random from '@/mixins/random';

export default {
	name: 'GameOver',
	mixins: [random, tracking],
	components: {
		Button,
		ShareButtons,
	},
	data() {
		return {
			scores: this.$store.state.scores,
		};
	},
	computed: {
		...mapState({ // get data from wordpress Game Stage config page
			game_over: state => state.config.data.game_over,
			game_config: state => state.config.data.game_config,
			isBrainPop: state => state.config.data.game_config.brain_pop,
		}),
		getPlayerName() {
			return this.$store.state.playerName;
		},
		getAdjective() {
			return this.$store.state.adjective;
		},
		getNumberCorrect() {
			let count = 0;
			for (let i = 0; i < this.scores.length; i += 1) {
				if (this.scores[i] === 1) {
					count += 1;
				}
			}
			return count;
		},
		getTotalRequests() {
			return this.scores.length;
		},
		calculatePercent() {
			const perc = Number(this.getNumberCorrect) / Number(this.getTotalRequests);
			const stars = Math.round(perc * 5);
			return stars;
		},
		performance() {
			const score = this.$store.state.score;
			if (score < 1.67) {
				return 'good';
			}
			return 'bad';
		},
	},
	methods: {
		redirect() {
			this.trackEvent('Click', 'Game', 'Replay');
			this.$router.push({ name: 'Title' });
		},
	},
	mounted() {
		this.trackPageview('game-over', `/game-over/?correct=${this.getNumberCorrect}`);
	},
};
</script>
<style lang="scss">
	.game-over-content{
		.game-over-title{
			line-height: normal;
			font-size: 1.3em;
			& .red {
				color: $red;
			}
			& p{
				margin-top: 0;
			}
			@include breakpoint(xsm){
				font-size: 1.1em;
			}
		}
		.game-over2{
			p:last-of-type{
				margin-top: 1rem;
				margin-bottom: 0;
			}
		}
		p{
			letter-spacing: 0.08em;
			font-size: 1.25em;
			@include breakpoint(sm){
				font-size: 1em;
			}
			@include breakpoint(xsm){
				font-size: 0.8em;
			}
		}
		a {
			color: $gold;
			text-decoration: none;
			border-bottom: 1px solid $gold;
			transition: none;
			&:active, &:visited {
				border-bottom: 1px solid $gold;
				color: $gold;
				text-decoration: none;
			}
			&:hover, &:focus {
				border-bottom: 3px solid $gold;
				color: $gold;
				text-decoration: none;
			}
		}
		&.vb > .vb-dragger > .vb-dragger-styler,
		&.vb > .vb-dragger:hover > .vb-dragger-styler,
		&.vb.vb-dragging > .vb-dragger > .vb-dragger-styler,
		&.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler{
			background-color: rgba(255,255,255, 0.5);
		}
		&.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
			background-color: rgba(255, 255, 255, 0.3);
		}
	}
</style>
<style lang="scss" scoped>
	@import '../../assets/styles/utilities/**/*.scss';
	.game-over-content {
		color: $gold;
		width: 100%;
		height: 100%;
		background-color: #161616;
		.game-over-bg{
			position: absolute;
			background-color: #161616;
			height: 100%;
			width: 200vw;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
		}
		.component-container{
			pointer-events: none;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			.topBar{
				width: 100vw;
				height: 6.25%;
				background-position: top left;
				background-color: transparent;
				background-repeat: repeat-x;
				background-size: auto 100%;
				-webkit-filter: blur(0px);
				position: absolute;
			}
			.playerName{
				width: auto;
				height: auto;
				min-width: 250px;
				padding: 1%;
				background-color: $gold;
				box-shadow: 0 0 0 5px #94671B, 0 0 0 10px black;
				font-weight: normal;
				text-align: center;
				display: inline-flex;
				position: relative;
				color: black;
				font-size: 1.7em;
				line-height: 1em;
				font-family: $sabo-filled;
				justify-content: center;
				align-items: center;
				white-space: nowrap;
				@include breakpoint(md) {
					box-shadow: 0 0 0 4px #94671B, 0 0 0 8px black;
					font-size: 1.5em;
				}
				@include breakpoint(sm) {
					box-shadow: 0 0 0 3px #94671B, 0 0 0 6px black;
					font-size: 1.25em;
				}
				@include breakpoint(xsm) {
					font-size: 1.0625em;
				}
				@include breakpoint(xs) {
					font-size: 0.9375em;
				}
			}
		}
		.shark-rating-container{
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			margin-top: 3%;
			& .label{
				margin-right: 5px;
				color: $red;
				letter-spacing: 0.1em;
				margin-top: -1.5%;
			}
			& .symbols{
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				& .symbol{
					margin: 0 2px;
				}
			}
		}
		.vuebar-element{
			height: 100%;
			position: absolute !important;
			padding-top: 11%;
			@include breakpoint(xl){
				padding-top: 12%;
			}
			@include breakpoint(lg){
				padding-top: 12.5%;
			}
			@include breakpoint(xmd){
				padding-top: 13%;
			}
			@include breakpoint(md){
				padding-top: 13.5%;
			}
			@include breakpoint(sm){
				padding-top: 14%;
			}
			@include breakpoint(xsm){
				padding-top: 14.5%;
			}
			@include breakpoint(xs){
				padding-top: 15%;
			}
		}
		.vuebar-content{
			display: flex !important;
		}
		.content {
			text-align: center;
			width: 90%;
			max-width: 580px;
			height: auto;
			margin: auto;
			padding-bottom: 30px;
			@include breakpoint(xs){
				padding-bottom: 15px;
			}
		}
		&.vb-visible .vuebar-content{
			display: block !important;
		}
		&.vb-visible .content{
			top: 20px;
			transform: none;
		}
	}
	a{
		color: $gold;
		&:hover, &:active, &:visited{
			color: $gold;
		}
	}
	.startOverBtn{
		display: inline-block;
		vertical-align: middle;
		margin: 0 30px 0 0;
	}
	.hidden { display: none; }
</style>



// WEBPACK FOOTER //
// src/components/views/GameOver.vue